(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-section]').forEach((section) => {
    const form = section.querySelector('[data-cart-form]')
    if (!form) return

    const errorMessage = form.querySelector('[data-cart-error]')

    form.querySelectorAll('[data-quantity-step]').forEach((button) => {
      button.addEventListener('click', () => {
        const input = document.getElementById(button.getAttribute('aria-controls'))
        if (!input) return
        if (Number(button.dataset.quantityStep) > 0) input.stepUp()
        else input.stepDown()
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
    })

    form.addEventListener('submit', async (event) => {
      if (!event.submitter || event.submitter.name !== 'update') return
      if (!form.checkValidity()) return

      event.preventDefault()
      event.submitter.disabled = true
      errorMessage.hidden = true

      try {
        const response = await fetch(form.dataset.updateUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
        const result = await response.json().catch(() => ({}))
        if (!response.ok) throw new Error(result.description || result.message || form.dataset.errorMessage)
        window.location.reload()
      } catch (error) {
        errorMessage.textContent = error.message || form.dataset.errorMessage
        errorMessage.hidden = false
        errorMessage.focus()
        event.submitter.disabled = false
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-site-header].site-header--overlay').forEach((header) => {
    const hero = document.querySelector('.editorial-hero')
    if (!hero || !('IntersectionObserver' in window)) return

    header.classList.add('is-enhanced')
    const heroObserver = new IntersectionObserver(([entry]) => {
      header.classList.toggle('is-scrolled', !entry.isIntersecting)
    })
    heroObserver.observe(hero)
  })

  document.querySelectorAll('[data-mobile-navigation]').forEach((navigation) => {
    const focusableSelector = 'summary, a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'

    navigation.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && navigation.open) {
        navigation.open = false
        navigation.querySelector('summary')?.focus()
      }

      if (event.key === 'Tab' && navigation.open) {
        const focusableElements = Array.from(navigation.querySelectorAll(focusableSelector))
        const firstElement = focusableElements[0]
        const lastElement = focusableElements[focusableElements.length - 1]

        if (event.shiftKey && document.activeElement === firstElement) {
          event.preventDefault()
          lastElement?.focus()
        } else if (!event.shiftKey && document.activeElement === lastElement) {
          event.preventDefault()
          firstElement?.focus()
        }
      }
    })

    navigation.addEventListener('click', (event) => {
      if (event.target.closest('a')) navigation.open = false
    })
  })

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-mobile-navigation][open]').forEach((navigation) => {
      if (!navigation.contains(event.target)) navigation.open = false
    })
  })

  document.addEventListener('cart:refresh', (event) => {
    const itemCount = Number(event.detail?.item_count)
    if (!Number.isFinite(itemCount)) return

    document.querySelectorAll('[data-cart-link]').forEach((cartLink) => {
      cartLink.setAttribute('aria-label', cartLink.dataset.cartCountLabel.replace('__COUNT__', String(itemCount)))
      let countElement = cartLink.querySelector('.site-header__cart-count')

      if (itemCount > 0) {
        if (!countElement) {
          countElement = document.createElement('span')
          countElement.className = 'site-header__cart-count'
          countElement.setAttribute('aria-hidden', 'true')
          cartLink.append(countElement)
        }
        countElement.textContent = itemCount
      } else {
        countElement?.remove()
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.recommendationsUrl
        if (!url) return

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const documentHtml = new DOMParser().parseFromString(text, 'text/html')
            const recommendedGrid = documentHtml.querySelector('[data-related-grid]')
            if (!recommendedGrid || !recommendedGrid.children.length) return

            const recommendedSection = documentHtml.querySelector('product-recommendations')
            if (recommendedSection) {
              this.innerHTML = recommendedSection.innerHTML
              document.dispatchEvent(new CustomEvent('wishlist:refresh'))
            }
          })
          .catch(() => {})
      }
    })
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]')
    const variantsElement = section.querySelector('[data-product-variants]')
    if (!form || !variantsElement) return

    const variants = JSON.parse(variantsElement.textContent)
    const selectors = Array.from(form.querySelectorAll('[data-option-selector]'))
    const variantInput = form.querySelector('[data-variant-id]')
    const price = section.querySelector('[data-current-price]')
    const comparePrice = section.querySelector('[data-compare-price]')
    const saleBadge = section.querySelector('[data-sale-badge]')
    const offerSaving = section.querySelector('[data-offer-saving]')
    const priceLabel = section.querySelector('[data-price-label]')
    const inventoryMessage = section.querySelector('[data-inventory-message]')
    const mobilePrice = section.querySelector('[data-mobile-price]')
    const submitButtons = section.querySelectorAll('[data-product-submit]')
    const message = form.querySelector('[data-form-message]')
    const mobilePurchase = section.querySelector('[data-mobile-purchase]')

    const updateOptionAvailability = () => {
      selectors.forEach((selector, selectorIndex) => {
        Array.from(selector.options).forEach((option) => {
          const available = variants.some((variant) => {
            if (variant.options[selectorIndex] !== option.value) return false
            return selectors.slice(0, selectorIndex).every((previousSelector, previousIndex) => {
              return variant.options[previousIndex] === previousSelector.value
            })
          })
          option.disabled = !available
        })

        if (selector.selectedOptions[0]?.disabled) {
          const firstAvailable = Array.from(selector.options).find((option) => !option.disabled)
          if (firstAvailable) selector.value = firstAvailable.value
        }
      })
    }

    const updateVariant = () => {
      updateOptionAvailability()
      const selectedOptions = selectors.map((selector) => selector.value)
      let variant = variants.find((item) => item.options.every((value, index) => value === selectedOptions[index]))
      if (!selectors.length) variant = variants.find((item) => String(item.id) === variantInput.value) || variants[0]

      if (!variant) {
        if (offerSaving) offerSaving.hidden = true
        variantInput.value = ''
        inventoryMessage.textContent = section.dataset.unavailableLabel
        submitButtons.forEach((button) => {
          button.disabled = true
          button.querySelector('[data-submit-label]').textContent = section.dataset.unavailableLabel
        })
        return
      }

      variantInput.value = variant.id
      price.textContent = variant.price
      mobilePrice.textContent = variant.price
      comparePrice.textContent = variant.compareAtPrice
      comparePrice.hidden = !variant.onSale
      saleBadge.hidden = !variant.onSale
      if (offerSaving) {
        offerSaving.textContent = variant.savingText
        offerSaving.hidden = !variant.onSale || !variant.available
      }
      priceLabel.textContent = variant.onSale ? section.dataset.salePriceLabel : section.dataset.priceLabel
      inventoryMessage.textContent = variant.inventoryText
      submitButtons.forEach((button) => {
        button.disabled = !variant.available
        button.querySelector('[data-submit-label]').textContent = variant.available ? section.dataset.addLabel : section.dataset.soldOutLabel
      })

      const url = new URL(section.dataset.productUrl, window.location.origin)
      url.searchParams.set('variant', variant.id)
      window.history.replaceState({}, '', url)

      if (variant.featuredMediaId) {
        const media = section.querySelector(`[data-media-id="${variant.featuredMediaId}"]`)
        const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        media?.scrollIntoView({ behavior: scrollBehavior, block: 'nearest', inline: 'start' })
      }
    }

    selectors.forEach((selector) => selector.addEventListener('change', updateVariant))
    updateVariant()

    section.querySelectorAll('[data-quantity-selector]').forEach((quantitySelector) => {
      const input = quantitySelector.querySelector('input')
      quantitySelector.querySelector('[data-quantity-minus]').addEventListener('click', () => {
        input.stepDown()
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
      quantitySelector.querySelector('[data-quantity-plus]').addEventListener('click', () => {
        input.stepUp()
        input.dispatchEvent(new Event('change', { bubbles: true }))
      })
    })

    form.addEventListener('submit', async (event) => {
      if (!event.submitter?.matches('[data-product-submit]')) return
      event.preventDefault()
      submitButtons.forEach((button) => { button.disabled = true })
      message.textContent = ''

      try {
        const response = await fetch(section.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
        const result = await response.json()
        if (!response.ok) throw new Error(result.description || result.message)

        message.innerHTML = `<p>${section.dataset.successLabel} <a href="${section.dataset.cartUrl}">${section.dataset.viewCartLabel}</a></p>`
        try {
          const cartResponse = await fetch(`${section.dataset.cartUrl}.js`, { headers: { Accept: 'application/json' } })
          if (cartResponse.ok) {
            const cartState = await cartResponse.json()
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cartState }))
          }
        } catch {}
      } catch (error) {
        message.textContent = error.message || section.dataset.errorLabel
      } finally {
        const selectedVariant = variants.find((variant) => String(variant.id) === variantInput.value)
        submitButtons.forEach((button) => { button.disabled = !selectedVariant?.available })
        message.focus?.()
      }
    })

    const primarySubmit = form.querySelector('[data-product-submit]')
    if (primarySubmit && mobilePurchase && 'IntersectionObserver' in window) {
      let primarySubmitVisible = true
      let productSectionVisible = true
      const updateMobilePurchase = () => {
        mobilePurchase.hidden = primarySubmitVisible || !productSectionVisible
      }
      const submitObserver = new IntersectionObserver(([entry]) => {
        primarySubmitVisible = entry.isIntersecting
        updateMobilePurchase()
      }, { threshold: 0.25 })
      const sectionObserver = new IntersectionObserver(([entry]) => {
        productSectionVisible = entry.isIntersecting
        updateMobilePurchase()
      })
      submitObserver.observe(primarySubmit)
      sectionObserver.observe(section)
    }

    const galleryTrack = section.querySelector('[data-gallery-track]')
    const mediaButtons = section.querySelectorAll('[data-media-target]')
    mediaButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        document.getElementById(button.dataset.mediaTarget)?.scrollIntoView({ behavior: scrollBehavior, block: 'nearest', inline: 'start' })
      })
    })

    if (galleryTrack && mediaButtons.length) {
      galleryTrack.addEventListener('scroll', () => {
        const activeIndex = Math.round(galleryTrack.scrollLeft / galleryTrack.clientWidth)
        mediaButtons.forEach((button, index) => {
          button.classList.toggle('is-active', index === activeIndex)
          if (index === activeIndex) button.setAttribute('aria-current', 'true')
          else button.removeAttribute('aria-current')
        })
      }, { passive: true })
    }

    const lightbox = section.querySelector('[data-product-lightbox]')
    const lightboxTriggers = Array.from(section.querySelectorAll('[data-lightbox-trigger]'))
    if (lightbox && lightboxTriggers.length) {
      const lightboxImage = lightbox.querySelector('[data-lightbox-image]')
      const lightboxStage = lightbox.querySelector('[data-lightbox-stage]')
      const closeButton = lightbox.querySelector('[data-lightbox-close]')
      const previousButton = lightbox.querySelector('[data-lightbox-previous]')
      const nextButton = lightbox.querySelector('[data-lightbox-next]')
      const zoomInButton = lightbox.querySelector('[data-lightbox-zoom-in]')
      const zoomOutButton = lightbox.querySelector('[data-lightbox-zoom-out]')
      const resetButton = lightbox.querySelector('[data-lightbox-reset]')
      const zoomLevel = lightbox.querySelector('[data-lightbox-zoom-level]')
      let activeIndex = 0
      let activeTrigger = null
      let scale = 1
      let offsetX = 0
      let offsetY = 0
      let dragStart = null

      const renderTransform = () => {
        const maxX = Math.max(0, lightboxImage.clientWidth * (scale - 1) / 2)
        const maxY = Math.max(0, lightboxImage.clientHeight * (scale - 1) / 2)
        offsetX = Math.max(-maxX, Math.min(maxX, offsetX))
        offsetY = Math.max(-maxY, Math.min(maxY, offsetY))
        lightboxImage.style.transform = `translate3d(${offsetX}px, ${offsetY}px, 0) scale(${scale})`
        lightboxImage.classList.toggle('is-zoomed', scale > 1)
        zoomLevel.textContent = `${Math.round(scale * 100)}%`
        zoomOutButton.disabled = scale <= 1
        zoomInButton.disabled = scale >= 4
        resetButton.disabled = scale === 1
      }

      const resetZoom = () => {
        scale = 1
        offsetX = 0
        offsetY = 0
        renderTransform()
      }

      const showImage = (index) => {
        activeIndex = (index + lightboxTriggers.length) % lightboxTriggers.length
        const trigger = lightboxTriggers[activeIndex]
        lightboxImage.width = Number(trigger.dataset.lightboxWidth)
        lightboxImage.height = Number(trigger.dataset.lightboxHeight)
        lightboxImage.src = trigger.dataset.lightboxSrc
        lightboxImage.alt = trigger.dataset.lightboxAlt
        resetZoom()
      }

      const closeLightbox = () => {
        if (lightbox.open) lightbox.close()
      }

      lightboxTriggers.forEach((trigger, index) => {
        trigger.addEventListener('click', () => {
          activeTrigger = trigger
          showImage(index)
          previousButton.hidden = lightboxTriggers.length < 2
          nextButton.hidden = lightboxTriggers.length < 2
          lightbox.showModal()
          document.documentElement.classList.add('product-lightbox-open')
          closeButton.focus()
        })
      })

      closeButton.addEventListener('click', closeLightbox)
      previousButton.addEventListener('click', () => showImage(activeIndex - 1))
      nextButton.addEventListener('click', () => showImage(activeIndex + 1))
      zoomInButton.addEventListener('click', () => {
        scale = Math.min(4, scale + 0.5)
        renderTransform()
      })
      zoomOutButton.addEventListener('click', () => {
        scale = Math.max(1, scale - 0.5)
        if (scale === 1) {
          offsetX = 0
          offsetY = 0
        }
        renderTransform()
      })
      resetButton.addEventListener('click', resetZoom)

      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox()
      })
      lightbox.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' && lightboxTriggers.length > 1) {
          event.preventDefault()
          showImage(activeIndex - 1)
        }
        if (event.key === 'ArrowRight' && lightboxTriggers.length > 1) {
          event.preventDefault()
          showImage(activeIndex + 1)
        }
      })
      lightbox.addEventListener('close', () => {
        document.documentElement.classList.remove('product-lightbox-open')
        lightboxImage.removeAttribute('src')
        resetZoom()
        activeTrigger?.focus()
      })

      lightboxStage.addEventListener('pointerdown', (event) => {
        if (scale <= 1 || event.button > 0) return
        dragStart = { x: event.clientX - offsetX, y: event.clientY - offsetY }
        lightboxStage.setPointerCapture(event.pointerId)
        lightboxImage.classList.add('is-dragging')
      })
      lightboxStage.addEventListener('pointermove', (event) => {
        if (!dragStart) return
        offsetX = event.clientX - dragStart.x
        offsetY = event.clientY - dragStart.y
        renderTransform()
      })
      const endDrag = (event) => {
        if (!dragStart) return
        dragStart = null
        lightboxImage.classList.remove('is-dragging')
        if (lightboxStage.hasPointerCapture(event.pointerId)) lightboxStage.releasePointerCapture(event.pointerId)
      }
      lightboxStage.addEventListener('pointerup', endDrag)
      lightboxStage.addEventListener('pointercancel', endDrag)
      window.addEventListener('resize', renderTransform)
      resetZoom()
    }
  })

  } catch(e) { console.error(e); }
})();
})();
